/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer?: string };
type HookTuple = [
  { packageDetails: vp.PackageDetails },
  (packageId: string) => void,
  (packageId: string) => Promise<vp.PartnerBillingPackageDetailsResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchBillingPackagesDetails: ApiHook = ({ api, bearer }) => {
  const source = axios.CancelToken.source();

  const [packageId, setPackageId] = useState('');
  const [packageDetails, setPackageDetails] = useState<vp.PackageDetails>({});

  useEffect(() => {
    const loadData = async () => {
      const { PackageDetails } = await api.fetchBillingPackageDetails({ PackageID: packageId }, bearer, source);

      if (PackageDetails) setPackageDetails(PackageDetails);
    };

    if (packageId) void loadData();

    return () => {
      source.cancel();
    };
  }, [packageId]);

  const fetchDetails = async (_packageId: string): Promise<vp.PartnerBillingPackageDetailsResponse> => {
    const response = await api.fetchBillingPackageDetails({ PackageID: _packageId }, bearer, source);
    if (response.PackageDetails) setPackageDetails(response.PackageDetails);
    return response;
  };

  return [{ packageDetails }, (_packageId: string) => setPackageId(_packageId), fetchDetails];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchBillingPackagesDetails);
